function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M53.7 85l-44 10c-1.8.3-3.7-1.2-3.7-3V8c0-1.8 2-3.3 3.7-3l44 10a3 3 0 0 1 2.3 3v14c0 1.6-1.4 3-3 3s-3-1.4-3-3V20.4l-38-8.6v76.4l38-8.6V68c0-1.6 1.4-3 3-3s3 1.4 3 3v14c0 1.4-1.1 2.7-2.3 3z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M94 50c0 .7-.3 1.5-.8 2l-16 17c-1.1 1-3.2 1.4-4.4.3-1.2-1-1.1-3.2 0-4.4L84.1 53H21a3 3 0 0 1 0-6h63L72.9 35c-1-1-1.2-3.2 0-4.3 1.2-1.1 3.3-.8 4.4.2l16 17c.5.6.8 1.3.8 2.1z"
});

var SvgExport = function SvgExport(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 110 110",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgExport, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/export.6ff974ba.svg";
export { ForwardRef as ReactComponent };